import $ from "jquery";

Drupal.behaviors.expand = {
  attach: function(context) {
    const expandBtn = $('.expand-button', context);
    expandBtn.click(function(event) {
      var index = expandBtn.index(this); 
      var coworkerClone = $(this).clone().removeClass('coworker--teaser expand-button').addClass('coworker-expanded');

      $('.coworker-expanded').remove();

      //Append coworker to the first element with class: 'expandable', next to the clicked element
      $(this).nextAll('.expandable:first').append(coworkerClone);
 
      expandBtn.removeClass("btn-active");
      expandBtn[index].className += " btn-active";

      //When click on close button
      $('.expandable-close-button').click(function(event) {
        expandBtn.removeClass("btn-active");
        $('.coworker-expanded').remove();
        event.stopPropagation();
      }); 

      // Dont do anything if expanded section clicked
      $('.coworker-expanded').click(function(event) {
        event.stopPropagation();
      }); 

      event.stopPropagation();
    });

    //If esc is pressed
    $(document).keyup(function(e) {
      if (e.keyCode === 27) {
        expandBtn.removeClass("btn-active");
        $('.coworker-expanded').remove();
      }
    });
  }
};
